"use client";

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import { MessageCircle } from "lucide-react";
import { SupportChatPanel } from "./SupportChatPanel";

const HIDE_PATH_PREFIXES = [
  "/connect-admin",
  "/auth/login",
  "/auth/signup",
  "/music-analysis/analyze",
  "/lessons/classroom",
  "/lessons/test-room",
  "/lessons/call",
  "/realtime-feedback/demo",
];

export function SupportChatbot() {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);

  const shouldHide =
    HIDE_PATH_PREFIXES.some(p => pathname?.startsWith(p)) || pathname === "/";

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  if (shouldHide) return null;

  return (
    <>
      {open && (
        <div
          className="fixed z-[10001] flex flex-col shadow-2xl border border-gray-200 overflow-hidden
            inset-x-3 bottom-[calc(var(--bottom-nav-total-height)+0.75rem)] h-[min(520px,calc(100dvh-var(--bottom-nav-total-height)-5rem))]
            sm:inset-x-auto sm:right-6 sm:bottom-6 sm:w-[380px] sm:h-[520px] sm:rounded-2xl rounded-2xl"
          role="dialog"
          aria-label="ConnecTone AI 상담"
        >
          <SupportChatPanel
            variant="floating"
            autoInit
            onClose={() => setOpen(false)}
          />
        </div>
      )}

      {!open && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="fixed z-[10001] flex items-center gap-2 px-4 py-3 rounded-full shadow-lg
            bg-gradient-to-r from-[#280a49] to-purple-700 text-white
            hover:from-purple-800 hover:to-purple-900 transition-all hover:scale-105 active:scale-95
            right-4 bottom-[calc(var(--bottom-nav-total-height)+0.75rem)]
            sm:right-6 sm:bottom-6"
          aria-label="AI 상담 열기"
        >
          <MessageCircle className="w-5 h-5" />
          <span className="text-sm font-medium hidden sm:inline">AI 상담</span>
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-teal-400 rounded-full border-2 border-white" />
        </button>
      )}
    </>
  );
}
